export default "__VITE_ASSET__llzpaQ$D__"